import { Component  } from '@angular/core';
import { Router } from '@angular/router';
import { Api, Session } from '../services/index';

@Component({
  selector: 'psychiatry-what-we-treat',
  templateUrl: './psychiatry-what-we-treat.html',
  styleUrls: ['./psychiatry-what-we-treat.css']
})

export class PsychiatryWhatWeTreat {

  constructor(private router: Router, public session: Session) { }

  // continue(){
  //   this.router.navigateByUrl('/dashboard-medical/1');
  // }
	requestExam(){
		this.router.navigateByUrl('/exam-request-care-today');
  }
  
  gotoDashboard() {
    this.router.navigate(['/dashboard-medical/3']);
	}
  openRxPolicy(){
    window.open('http://memd.force.com/agreement/agreements?name=rxpolicypsy', "_blank");
  }
  
}
